import SettingFrame from "../../../../../components/@settings/SettingFrame"
import ViewRequest from "../../../../../components/@schedulers/request/ViewRequest";

import { routeTypes } from "../../../../../hooks/useSystemRoutes";

export default function RequestViewPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ViewRequest 
                routeType={routeType}
            />
        </SettingFrame>
    )
}       